// The text-message consent box. Its wording is the opt-in our toll-free number's
// carrier registration describes (docs/sms-mfa/optin-mockup.html): change it only
// together with a new registration version (docs/sms-mfa/RUNBOOK.md) and the backend
// copy in Backend/123bimlive/utils/sms_consent.py — smsConsent.test.js keeps them equal.
export const CONSENT_VERSION = '2026-10-v1';

const HELP_EMAIL = 'inquiries@rdvsystems.com';
const SMS_TERMS_URL = 'https://www.rdvsystems.com/sms-terms';
const PRIVACY_URL = 'https://www.rdvsystems.com/privacy-policy';

// Text and links, in order, as the consent label renders them.
export const CONSENT_PARTS = [
  'I agree to receive one-time passcodes by text message from RDV Systems for sign-in and password reset. '
    + 'Message frequency varies (one message per sign-in or reset request). '
    + 'Message and data rates may apply. Reply STOP to opt out. Help: ',
  { href: `mailto:${HELP_EMAIL}`, text: HELP_EMAIL },
  '. SMS Terms: ',
  { href: SMS_TERMS_URL, text: SMS_TERMS_URL },
  '. Privacy Policy: ',
  { href: PRIVACY_URL, text: PRIVACY_URL },
  '.',
];

export const CONSENT_TEXT = CONSENT_PARTS.map((part) => (typeof part === 'string' ? part : part.text)).join('');

const NANP = /^1[2-9]\d{2}[2-9]\d{6}$/;

/** E.164 for a number as typed, or null — the same rules as the backend's normalize_phone. */
export function toE164(raw, { international = false } = {}) {
  const text = String(raw || '').trim();
  const digits = text.replace(/\D/g, '');
  if (text.startsWith('+')) {
    if (digits.startsWith('1')) return NANP.test(digits) ? `+${digits}` : null;
    if (international && digits.length >= 8 && digits.length <= 15 && !digits.startsWith('0')) {
      return `+${digits}`;
    }
    return null;
  }
  const us = digits.length === 10 ? `1${digits}` : digits;
  return NANP.test(us) ? `+${us}` : null;
}

/** +16035550142 -> "+1 (603) 555-0142"; other countries stay as E.164. */
export function formatPhone(e164) {
  const match = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164 || '');
  return match ? `+1 (${match[1]}) ${match[2]}-${match[3]}` : (e164 || '');
}

export function badPhoneMessage(international) {
  return international
    ? 'Enter a valid mobile number. For numbers outside the US, start with + and the country code.'
    : 'Enter a valid US mobile number.';
}
